const Language = {
    EN: "en",
    TH: "th"
}

export default Language;